<icc-list
[searchable]="searchable"
[items]="items"  
(select)="selectItem($event)" 
[itemTemplate]="itemTemplate"
[selected]="selectedItemId"
[tabs]="tabGroups"
(showInfo)="showInfo($event)"
></icc-list>
